import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Room } from '@library/store/rooms/rooms.interface';
import { RoomsAssets } from '@library/utils/constants/rooms';
import { LangPipe } from '@library/utils/pipes/lang.pipe';
import { ControlPageAssistantService } from '@pages/control-page/control-page-assistant/control-page-assistant.service';
import { Enums } from 'constants/Enums.constant';

@Component({
  selector: 'app-assistant-add-room',
  templateUrl: './assistant-add-room.component.html',
  styleUrls: ['./assistant-add-room.component.scss']
})
export class AssistantAddRoomComponent {

  roomTypes = [
    {label: this.langPipe.transform(RoomsAssets.bathroom.name),           value: Enums.RoomTypes.BATHROOM},
    {label: this.langPipe.transform(RoomsAssets.bedroom.name),            value: Enums.RoomTypes.BEDROOM},
    {label: this.langPipe.transform(RoomsAssets.corridor.name),           value: Enums.RoomTypes.CORRIDOR},
    {label: this.langPipe.transform(RoomsAssets.custom.name),             value: Enums.RoomTypes.CUSTOM},
    {label: this.langPipe.transform(RoomsAssets.dining_room.name),        value: Enums.RoomTypes.DINING_ROOM},
    {label: this.langPipe.transform(RoomsAssets.electrical_cabinet.name), value: Enums.RoomTypes.ELECTRICAL_CABINET},
    {label: this.langPipe.transform(RoomsAssets.garage.name),             value: Enums.RoomTypes.GARAGE},
    {label: this.langPipe.transform(RoomsAssets.home_office.name),        value: Enums.RoomTypes.HOME_OFFICE},
    {label: this.langPipe.transform(RoomsAssets.kitchen.name),            value: Enums.RoomTypes.KITCHEN},
    {label: this.langPipe.transform(RoomsAssets.livingroom.name),         value: Enums.RoomTypes.LIVINGROOM},
    {label: this.langPipe.transform(RoomsAssets.lobby.name),              value: Enums.RoomTypes.LOBBY},
    {label: this.langPipe.transform(RoomsAssets.outdoor.name),            value: Enums.RoomTypes.OUTDOOR},
    {label: this.langPipe.transform(RoomsAssets.stairs.name),             value: Enums.RoomTypes.STAIRS},
    {label: this.langPipe.transform(RoomsAssets.toilets.name),            value: Enums.RoomTypes.TOILETS},
  ];

  formGroup = new FormGroup({
    type: new FormControl(this.roomTypes[0]),
    name: new FormControl<string>(this.roomTypes[0].label, [Validators.required, Validators.minLength(1)]),
  });

  get type() {
    return this.formGroup.controls.type;
  }

  get name() {
    return this.formGroup.controls.name;
  }

  RoomsAssets = RoomsAssets;

  constructor(
    private langPipe: LangPipe,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private assisstantService: ControlPageAssistantService,
  ) {}

  ngOnInit() {
    this.type.valueChanges.subscribe((type) => {
      this.name.setValue(type.label);
    });
  }

  submit() {
    this.assisstantService.newRooms.next([{
      room: {
        id: this.assisstantService.uniqueRoomId(),
        name: this.name.value,
        type: this.type.value.value,
      } as Room, modules: []}]);
    this.router.navigate(['..'], {relativeTo: this.activatedRoute, skipLocationChange: true});
  }

}
